import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilteredStore } from "src/models/Stores/Store.models";

interface FilteredStoreState {
  filteredStores: IFilteredStore[];
  filteredStoreToEdit: IFilteredStore | null;
}

const initialState: FilteredStoreState = {
  filteredStores: [],
  filteredStoreToEdit: null,
};

const filteredStoreSlice = createSlice({
  name: "FilteredStore",
  initialState,
  reducers: {
    setFilteredStoreList: (state, action: PayloadAction<IFilteredStore[]>) => {
      state.filteredStores = action.payload;
    },
    concatListFilteredStore: (state: FilteredStoreState, action: PayloadAction<IFilteredStore[]>) => {
      state.filteredStores = [...state.filteredStores.concat(action.payload)];
    },
    setFilteredStoreToEdit: (state, action: PayloadAction<IFilteredStore | null>) => {
      state.filteredStoreToEdit = action.payload;
    },
    addFilteredStore: (state, action: PayloadAction<IFilteredStore>) => {
      state.filteredStores.push(action.payload);
    },
    addFilteredStores: (state, action: PayloadAction<IFilteredStore[]>) => {
      state.filteredStores.push(...action.payload);
    },
    updateFilteredStore: (state, action: PayloadAction<IFilteredStore>) => {
      let itemIndex = state.filteredStores.findIndex(
        item => item.storeId === action.payload.storeId
      );
      if (itemIndex !== -1) state.filteredStores[itemIndex] = action.payload;
    },
    deleteFilteredStore: (state, action: PayloadAction<number>) => {
      const newArray = state.filteredStores.filter(
        item => item.storeId !== action.payload
      );
      state.filteredStores = newArray;
    },
  },
});

export const {
  setFilteredStoreList,
  concatListFilteredStore,
  setFilteredStoreToEdit,
  addFilteredStore,
  addFilteredStores,
  updateFilteredStore,
  deleteFilteredStore,
} = filteredStoreSlice.actions;

export default filteredStoreSlice.reducer;
